module.exports = __webpack_public_path__ + "img/pie-chart-bg.c8ce8417.svg";